<template>
    <main
        class="assistente-conhecimento-admin"
        :class="{ 'assistente-conhecimento-admin--menu-aberto': menuAberto }"
        :style="estiloDoConteudo"
    >
        <div class="container-fluid px-3 px-md-4 py-4">
            <slot></slot>
        </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            larguraDoMenu: 0,
            observadorDoMenu: null,
        };
    },
    computed: {
        menuAberto() {
            return this.$store.state.isMenuOpen;
        },
        estiloDoConteudo() {
            if (!this.menuAberto || this.larguraDoMenu <= 0) {
                return {};
            }

            return {
                paddingLeft: `${this.larguraDoMenu}px`,
            };
        },
    },
    watch: {
        menuAberto() {
            this.$nextTick(this.atualizarDimensoes);
        },
    },
    mounted() {
        this.atualizarDimensoes();
        window.addEventListener('resize', this.atualizarDimensoes);

        const menu = document.querySelector('.menu-lateral');

        if (menu && window.ResizeObserver) {
            this.observadorDoMenu = new ResizeObserver(this.atualizarDimensoes);
            this.observadorDoMenu.observe(menu);
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.atualizarDimensoes);

        if (this.observadorDoMenu) {
            this.observadorDoMenu.disconnect();
        }
    },
    methods: {
        atualizarDimensoes() {
            const menu = document.querySelector('.menu-lateral');
            this.larguraDoMenu = menu ? menu.getBoundingClientRect().width : 0;
        },
    },
};
</script>

<style scoped>
.assistente-conhecimento-admin {
    box-sizing: border-box;
    min-width: 0;
    width: 100%;
    transition: padding-left 0.5s ease;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__cabecalho) {
    align-items: flex-start;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 1.5rem;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__cabecalho-acoes),
.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__acoes) {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: flex-end;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__card) {
    border-left: 4px solid #198754;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__conteudo) {
    font-family: inherit;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__codigo) {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__rodape) {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__rodape .pagination) {
    margin-bottom: 0;
}

.assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__resultado-cabecalho) {
    align-items: flex-start;
    display: flex;
    gap: 0.75rem;
    justify-content: space-between;
}

@media (max-width: 767.98px) {
    .assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__cabecalho) {
        flex-direction: column;
    }

    .assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__cabecalho-acoes),
    .assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__acoes) {
        justify-content: flex-start;
    }

    .assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__rodape),
    .assistente-conhecimento-admin :deep(.assistente-conhecimento-admin__resultado-cabecalho) {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
